import { useNavigator } from '@repo/toolkit/use-navigator'
import { InstructionIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createTripBookingGuideline } from '../../api/trip-booking-guidelines/create-trip-booking-guideline'
import UserNavBar from '../../components/elements/nav-bar'
import TripBookingGuidlineForm from '../../components/pages/trip-booking-guidelines/trip-booking-guideline-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const TripBookingGuidelineCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createTripBookingGuideline,
    onError: showAxiosError,
    onSuccess: () => toast.success('Consigne créée avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer une consigne'} icon={InstructionIcon} />
      <div className={'h-4'} />
      <TripBookingGuidlineForm
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (values) => {
            const res = await mutateAsync(values)
            navigate(Paths.TRIP_BOOKING_GUIDELINE_UPDATE_PAGE.replace(':id', res.id.toString()), {
              replace: true
            })
          },
          onCancel: () => back(Paths.TRIP_BOOKING_GUIDELINE_LIST_PAGE)
        })}
      />
    </div>
  )
}

export default TripBookingGuidelineCreatePage
